import {actions} from 'forms/rrf';
import {toast} from 'react-toastify';
import store, {history} from '../store';
import irelandApi from '../irelandApi';
import ToastMessage from '../components/common/toast-message';

export const getPointsTypes = () => (dispatch) => {
  dispatch({type: 'GET_POINTS_TYPES_LIST_PENDING'});
  return irelandApi.get('/api/admin/points_types')
    .then((response) => {
      dispatch({type: 'GET_POINTS_TYPES_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_POINTS_TYPES_LIST_REJECTED', payLoad: error.data});
    });
};

export const getPointsType = id => (dispatch) => {
  dispatch({type: 'GET_POINTS_TYPE_PENDING'});
  return irelandApi.get(`/api/admin/points_types/${id}`)
    .then((response) => {
      dispatch(actions.load('deep.pointsType', response.data.data.attributes));
      dispatch({type: 'GET_POINTS_TYPE_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_POINTS_TYPE_REJECTED', payLoad: error.data});
    });
};

export const updatePointsType = (id, payLoad) => {
  const formData = new FormData();
  formData.append('points_type[icon]', payLoad.icon);
  formData.append('points_type[news_feed]', payLoad['news-feed']);

  const config = {
    headers: {'content-type': 'multipart/form-data'}
  };
  return irelandApi.put(`/api/admin/points_types/${id}`, formData, config)
    .then(() => {
      toast.success(<ToastMessage
        iconStyle="success"
        message="Points type has been saved successfully"
      />);
      history.push('/admin/points-types');
    })
    .catch((error) => {
      toast.error(<ToastMessage
        iconStyle="error"
        message="An error occurred during save points type"
      />);
      store.dispatch(actions.resetValidity('deep.pointsType'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    });
};
